<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import createModal from "./create_modal.vue";

import datatableMixin from '@/helpers/mixins/datatableMixin'
import Datatable from '@/components/Datatable'

export default {
  page: {
    title: "Bayi Yönetimi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader, 
    createModal,
    Datatable
  },
  mixins: [ datatableMixin],
  data() {
    return { 
        list: {},
        title: "BAYİ LİSTESİ",
        items: [
          {
            text: "ANASAYFA",
            href: "/",
          },
          {
            text: "BAYİ LİSTESİ",
            active: true,
          },
        ],


        columns: [
          { name: '', key: 'action', orderable: false, width:10  },
          { name: 'İsim Soyisim', key: 'name', orderable:true, width: 150 },
          { name: 'Kullanıcı Adı', key: 'username', className: 'text-end', orderable:true, width: 150  },
          { name: 'Telefon', key: 'phonenumber', className: 'text-end', width: 150  },
          { name: 'Durum', key: 'status', className: 'text-end', width: 150  },
        ],
        tableData: {
          detail: false,
          excel: false,
          searchable:{
            visible:true,
            placeholder:"İsim Soyisim de Ara"
          }
        },
        endpoint: '/dealers',
        opened:0,
        abilityCount:0
    };
  },

  methods: {

    async loadPage() {
          
      this.params.page === 1 ?   this.isLoading = true : this.pageLoading = true
      
      const response = await  this.$http.post(this.endpoint, { params: this.params, search_params: this.searchParams, sort:this.sort, search_query: this.searchQuery });
      if (this.params.page === 1) {
          this.tableData.data = response.data.data;
      } else {
          this.tableData.data = [...this.tableData.data, ...response.data.data];
      }
  
      this.tableData.pagination = { current_page:response.data.current_page,  last_page:response.data.last_page, total:response.data.total };
      this.params.page === 1 ?   this.isLoading = false : this.pageLoading = false
    },

    create(){
       this.list = {}
       this.$parent.$bvModal.show('modal-scoped')
    },

    update(props, type){
       this.list = { ...props, type}
       this.$parent.$bvModal.show('modal-scoped')
    },
    
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <create-modal :list="list" @loadItems="loadPage"/>


    <div class="row"> 
      <div class="col-12">
        <Datatable 
              :columns="columns" 
              :tableData="tableData" 
              @sort-column="handleSortColumn"
              @search-query="reLoadPage"
              @excel-export="excelExport"
              :loading="isLoading"
              :poading="pageLoading">
            
        <template #button>
          <button class="btn btn-sm btn-success" @click="create()">Yeni Oluştur</button>
        </template>

        <template #status="{ row }">
          <span v-if="row.status"  class="badge rounded-pill bg-success"><i class="fa fa-check"></i> Aktif </span>
          <span v-if="!row.status"  class="badge rounded-pill bg-danger"><i class="fa fa-times"></i> Pasif </span>
        </template> 

        <template #action="{ row }">
              <b-dropdown
                  toggle-class="font-size-16 p-0"
                  toggle-tag="a"
                  variant="white"
                  append-to-body
                  >
                  <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                  </template> 
                    <b-dropdown-item @click="update(row,'update')">Düzenle</b-dropdown-item>
                    <b-dropdown-item @click="update(row,'password')">Şifre Güncelle</b-dropdown-item>
              </b-dropdown>
          </template>
        </Datatable>
      </div>
    </div>
  </Layout>
</template>
